import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import type { SeoPage, SeoSegment } from "./seo.types";

function mapRow(row: any): SeoPage {
  return {
    id: row.id,
    segment: row.segment,
    city_slug: row.city_slug,
    city_name: row.city_name,
    h1: row.h1,
    meta_title: row.meta_title,
    meta_description: row.meta_description,
    intro: row.intro,
    why_us: row.why_us ?? [],
    concepts: row.concepts ?? [],
    budget_guide: row.budget_guide ?? [],
    date_advice: row.date_advice ?? null,
    local_proof: row.local_proof ?? null,
    faq: row.faq ?? [],
    related_product_slugs: row.related_product_slugs ?? [],
    is_published: !!row.is_published,
  };
}

export const getSeoPage = createServerFn({ method: "GET" })
  .inputValidator((data: { segment: string; city: string }) => data)
  .handler(async ({ data }): Promise<SeoPage | null> => {
    const { data: row, error } = await supabaseAdmin
      .from("seo_pages")
      .select("*")
      .eq("segment", data.segment)
      .eq("city_slug", data.city)
      .eq("is_published", true)
      .maybeSingle();
    if (error) throw new Error(error.message);
    return row ? mapRow(row) : null;
  });

export const listSeoCitiesForSegment = createServerFn({ method: "GET" })
  .inputValidator((data: { segment: string }) => data)
  .handler(async ({ data }) => {
    const { data: rows, error } = await supabaseAdmin
      .from("seo_pages")
      .select("city_slug, city_name")
      .eq("segment", data.segment)
      .eq("is_published", true)
      .order("city_name");
    if (error) throw new Error(error.message);
    return (rows ?? []) as { city_slug: string; city_name: string }[];
  });

export const listAllSeoPaths = createServerFn({ method: "GET" }).handler(
  async () => {
    const { data, error } = await supabaseAdmin
      .from("seo_pages")
      .select("segment, city_slug")
      .eq("is_published", true);
    if (error) throw new Error(error.message);
    return (data ?? []) as { segment: SeoSegment; city_slug: string }[];
  },
);
